module.exports = __webpack_public_path__ + "img/scanSign.023d2be1.gif";